type CookieSameSite = "Strict" | "Lax" | "None";

type CookieOptions = {
  sameSite?: CookieSameSite;
  secure?: boolean;
  partitioned?: boolean;
};

export const getAll = (): Record<string, string | boolean> =>
  document.cookie.split("; ").reduce((prev: Record<string, string>, current) => {
    const [name, value] = current.split("=");
    prev[name] = value;
    return prev;
  }, {});

export const getCookie = (key: string) => {
  const cookieObj = getAll();
  return key.length ? cookieObj[key] : cookieObj;
};

export const setCookie = (
  name: string,
  value: string | boolean,
  path: string,
  expires?: string | number,
  options: CookieOptions = {}
) => {
  const ckValue = getCookie(name);
  const hasOptions = Boolean(options.sameSite || options.secure || options.partitioned);
  if (!hasOptions && (ckValue === value || ckValue === value.toString())) {
    return;
  }
  const cookiePath = path ? `; path=${path}` : "";
  const expiryDate = expires ? `; expires=${expires}` : "";
  const sameSite = options.sameSite ? `; SameSite=${options.sameSite}` : "";
  const secure = options.secure ? "; Secure" : "";
  const partitioned = options.partitioned ? "; Partitioned" : "";

  document.cookie = `${name}=${value}${cookiePath}${expiryDate}${sameSite}${secure}${partitioned}`;
};

export const removeCookie = (name: string, path = "/") => {
  setCookie(name, "", path, "Thu, 01 Jan 1970 00:00:00 GMT");
};

export function removeCookiesByPrefix(prefix: string) {
  const cookies = document.cookie.split(";");

  cookies.forEach((cookie) => {
    const [rawName] = cookie.split("=");
    const name = rawName.trim().toLocaleLowerCase();

    if (name.startsWith(prefix.toLocaleLowerCase())) {
      removeCookie(rawName);
    }
  });
}
